export default __webpack_public_path__ + "static/media/loadingKucingV3.c0c2c5a8.svg";